<template>
  <div class="row">
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div>
            <b-row>
              <b-col cols="12">
                <div class="text-right mb-2">
                  <b-button
                    v-if="creatable"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    v-b-modal.revenueSaveModal
                    variant="success"
                    class="ml-1"
                    @click="onCreateRevenue"
                  >
                    <feather-icon icon="PlusIcon" size="14" class="mr-50" />
                    <span class="text-nowrap text-right">Thêm mới</span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <vue-good-table
                  mode="remote"
                  class="my-table"
                  style-class="vgt-table striped bordered research-table"
                  row-style-class="vgt-row"
                  :columns="columns"
                  :rows="revenues"
                  :pagination-options="paginationOptions"
                  :total-rows="totalRows"
                  :line-numbers="true"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span v-if="props.column.field === 'stt'">
                      {{ props.row.originalIndex + 1 }}
                    </span>
                    <span v-if="props.column.field === 'is_exemption'">
                      {{ props.row.is_exemption === 1 ? 'Có' : 'Không' }}
                    </span>
                    <span v-else-if="props.column.field === 'type_id'">
                      {{ getRevenueTypesName(props.row.type_id) }}
                    </span>

                    <span v-else-if="props.column.field === 'action'">
                      <b-button
                        v-if="updatable"
                        v-b-modal.revenueSaveModal
                        variant="primary"
                        class="btn-icon"
                        size="sm"
                        @click="onEditRevenue(props.row)"
                      >
                        <feather-icon icon="Edit2Icon" />
                      </b-button>
                      <b-button
                        v-if="deletable"
                        variant="danger"
                        class="btn-icon"
                        style="margin-left: 6px"
                        size="sm"
                        @click="onDeletetRevenue(props.row)"
                      >
                        <feather-icon icon="TrashIcon" />
                      </b-button>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                  </template>

                  <!-- pagination -->
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                       <span class="text-nowrap"> Hiển thị {{filter.itemsPerPage * (filter.currentPage-1) +1}}
                        đến {{(filter.itemsPerPage * (filter.currentPage) >= totalRows)? totalRows : filter.itemsPerPage * (filter.currentPage)}} &nbsp; của {{ totalRows }} bản ghi
                      </span>
                      </div>
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị </span>
                        <b-form-select
                            v-model="filter.itemsPerPage"
                            :options="itemsPerPageOptions"
                            class="mx-1"
                            @input="(value) => props.perPageChanged({ currentPerPage: value })"
                        />
                        <span class="text-nowrap"> bản ghi/trang</span>
                      </div>
                      <div>
                        <b-pagination
                            :value="1"
                            :total-rows="totalRows"
                            :per-page="filter.itemsPerPage"
                            class="mt-1 mb-0"
                            @input="(value) => props.pageChanged({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
    <revenueSave
      ref="revenueSaveFormRef"
      :revenue="currentRevenue"
      @succeed="onSucceed"
    />
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BContainer, BFormSelect, BOverlay, BPagination, BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapActions, mapGetters } from 'vuex'
import { showSuccessToast, showErrorToast } from '@/utils/notification'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import revenueSave from '@/views/finance/revenue/RevenueSave.vue'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import { getUser } from '@/auth/utils'

export default {
  name: 'revenue',
  directives: {
    Ripple,
  },
  components: {
    revenueSave,
    BButton,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    VueGoodTable,
  },
  data() {
    return {
      isLoading: false,
      filter: {
        organization_id: getUser().orgId,
        currentPage: 1,
        itemsPerPage: 10,
        code: '',
        name: '',
        revenue: null,
        status: '',
        sort: '',
      },
      currentRevenue: undefined,
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
    }
  },
  computed: {
    ...mapGetters({
      revenues: 'revenue/revenues',
      totalRows: 'revenue/totalRows',
      revenueTypes: 'revenue/allRevenueTypes',
    }),
    revenueTypesFilterDropdownItems() {
      return this.revenueTypes.map(item => ({ value: item.id, text: item.name }))
    },
    columns() {
      return [
        {
          label: 'Tên khoản thu',
          field: 'name',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
          },
          sortable: true,
          thClass: 'text-center',
        },
        {
          label: 'Loại khoản thu',
          field: 'type_id',
          filterOptions: {
            enabled: true,
            trigger: 'enter',
            filterDropdownItems: this.revenueTypesFilterDropdownItems,
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Miễn giảm',
          field: 'is_exemption',
          filterOptions: {
            enabled: false,
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: '',
          field: 'action',
          width: '100px',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ]
    },
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.REVENUE)
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.REVENUE)
    },
    deletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.REVENUE)
    },
  },
  async created() {
    // Load initial data (revenue types) but not revenue list
    // Revenue list will be loaded when tab is activated or when refreshData is called
    try {
      await this.begin()
    } catch (e) {
      showErrorToast(this, e)
    }
  },
  methods: {
    ...mapActions({
      begin: 'revenue/begin',
      getRevenues: 'revenue/getRevenues',
      deleteRevenue: 'revenue/deleteRevenue',
    }),
    onCreateRevenue() {
      this.currentRevenue = undefined
    },
    onEditRevenue(revenue) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = revenue
      this.currentRevenue = rest
    },
    onDeletetRevenue(revenue) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa khoản thu <span class="text-danger">${revenue.name}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.deleteRevenue(revenue.id)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                showSuccessToast(this, message)
                try {
                  await this.getRevenues(this.filter)
                } catch (e) {
                  showErrorToast(this, e)
                }
              } else {
                showErrorToast(this, message)
              }
            }
          } catch (e) {
            showErrorToast(this, e)
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getRevenuesFromStore()
    },
    async getRevenuesFromStore() {
      this.isLoading = true
      try {
        await this.getRevenues(this.filter)
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getRevenuesFromStore()
    },
    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        if (field === 'name') this.updateParams({ sort: `1_${type}` })
        else if (field === 'code') this.updateParams({ sort: `2_${type}` })
        else this.updateParams({ sort: `3_${type}` })
      }
      await this.getRevenuesFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'name')) this.updateParams({ name: columnFilters.name })
      if (Object.hasOwn(columnFilters, 'code')) this.updateParams({ code: columnFilters.code })
      if (Object.hasOwn(columnFilters, 'type_id')) this.updateParams({ revenue: columnFilters.type_id })
      await this.getRevenuesFromStore()
    },

    async onSucceed() {
      await this.getRevenuesFromStore()
      // Emit event to notify parent component
      this.$emit('data-updated', 'revenue')
    },
    async refreshData() {
      // Method to refresh data, can be called from parent
      // Also refresh revenue types list
      this.isLoading = true
      try {
        await Promise.all([
          this.begin(),
          this.getRevenuesFromStore(),
        ])
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    getRevenueTypesName(id) {
      const type = this.revenueTypes.find(item => item.id === id)
      return type ? type.name : ''
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.mr-50 {
  margin-right: 0.5rem;
}
</style>
